module.exports = __webpack_public_path__ + "static/media/roble_atrani.cdc63037.jpg";